export const py = {
  pt: "base",
  pb: "small",
};

export const cellStyles = {
  ...py,
  px: "1x_small",
  color: "neutral.80",
};

export const cellStylesHeader = {
  ...cellStyles,
  verticalAlign: "middle",
  width: "135px",
};

export const cellLastColumnStyles = {
  ...py,
  pl: "small",
  pr: "base",
  color: "primary.70",
  backgroundColor: "primary.20",
};

export const cellLastColumnTopStyles = {
  ...cellLastColumnStyles,
  borderTopRightRadius: "8px",
  verticalAlign: "middle",
  width: "135px",
};

export const cellFirstColumnStyles = {
  ...py,
  px: "1x_small",
  color: "primary.70",
};

export const cellFooterTitleStyles = {
  py: "base",
  px: "1x_small",
  color: "primary.90",
};

export const cellFooterTextStyle = {
  p: "small",
  backgroundColor: "primary.20",
  borderBottomRightRadius: "8px",
};
